module.exports = __webpack_public_path__ + "static/media/5.68cb3c68.svg";